import { Box, Container, Flex, Text, Image, Divider, SimpleGrid, Input, InputGroup, FormControl, FormLabel, Textarea, Select, InputLeftElement, ButtonGroup, Button, Center, Heading, IconButton, FormErrorMessage } from "@chakra-ui/react";
import { ReactElement, useEffect, useState } from "react";
import LoadingScreen from "components/loading-screen";
import AuthService from "services/auth/auth-service";
import Layout from "scenes/layouts";
import LayoutAccount from "../layout-account";
import { FiFacebook, FiGlobe, FiInstagram, FiTwitter } from "react-icons/fi";
import { useNavigate } from "react-router-dom";
import { Field, Formik, useFormik } from "formik";
import LogosNotification from "../../../utils/notification-utils";
import { EditIcon } from "@chakra-ui/icons";
import { relative } from "path";
import { BsPencil } from "react-icons/bs";
import AppConsts from "../../../libs/appconst";

const formInitialValue = {
    firstName: '',
    surName: '',
    city: '',
    workProfession: '',
    workIndustry: '',
    about: '',
    website: '',
    facebook: '',
    twitter: '',
    instagram: '',
    dateOfBirthDay: null,
    dateOfBirthMonth: null,
    dateOfBirthYear: null
};

const EditProfile = (): ReactElement => {
    const navigate = useNavigate();
    const [isLoading, setLoad] = useState<boolean>(true);
    const [isSaving, setSaving] = useState<boolean>(false);
    const [userProfile, setUserProfile] = useState<any>(null);
    const [formValue, setFormValue] = useState<any>(formInitialValue);

    useEffect(() => {
        setLoad(true);
        AuthService.GetLoggedInUserProfile().then((res: any) => {
            setUserProfile(res.result);
            var profile = res.result;
            profile.dateOfBirthDay = profile.dateOfBirth ? new Date(profile.dateOfBirth).getDate() : null;
            profile.dateOfBirthMonth = profile.dateOfBirth ? new Date(profile.dateOfBirth).getMonth() : null;
            profile.dateOfBirthYear = profile.dateOfBirth ? new Date(profile.dateOfBirth).getFullYear() : null;
            setFormValue(profile);
        }).finally(() => {
            setLoad(false);
        });
    }, []);

    const handleFormSubmit = (values: any) => {
        setSaving(true);
        AuthService.EditProfile({
            firstName: values.firstName,
            surName: values.surName,
            city: values.city,
            workProfession: values.workProfession,
            workIndustry: values.workIndustry,
            about: values.about,
            website: values.website,
            facebook: values.facebook,
            twitter: values.twitter,
            instagram: values.instagram,
            dateOfBirth: new Date(values.dateOfBirthYear, values.dateOfBirthMonth, values.dateOfBirthDay)
        }).then((res: any) => {
            LogosNotification.Success("Profile berhasil diperbaharui.");
            navigate('/profile');
        }).finally(() => {
            setSaving(false);
        });
    };

    if (isLoading)
        return <LoadingScreen />;

    return (
        <Layout>
            <Container maxWidth={"8xl"} pt={10}>
                <LayoutAccount>
                    <Box>
                        <Flex>
                            <Text fontSize={'3xl'} fontWeight={"bold"}>Edit My Profile</Text>
                        </Flex>
                        <Formik initialValues={formValue} onSubmit={handleFormSubmit}>
                            {
                                ({ handleSubmit, errors, touched }) => (
                                    <form onSubmit={handleSubmit} noValidate={true}>
                                        <Box rounded={'lg'} boxShadow={'md'} fontSize={'sm'}>
                                            <Box px={8} py={4}>
                                                <FormControl>
                                                    <FormLabel htmlFor='profilePicture'>Profile Picture</FormLabel>
                                                    <Box boxSize={"150px"} mt={2}>
                                                        <Image rounded={'lg'} src={userProfile.profilePictureFullUrl || 'https://res.cloudinary.com/ruang-trader/image/upload/v1652634569/logosvillage/default-iser_nvxogs.webp'} />
                                                        {/*<IconButton*/}
                                                        {/*    isRound={true}*/}
                                                        {/*    position={'absolute'} bottom={0} ml={1} mb={1}*/}
                                                        {/*    aria-label='Edit Profile Picture'*/}
                                                        {/*    icon={<BsPencil />}*/}
                                                        {/*/>*/}
                                                    </Box>
                                                </FormControl>
                                            </Box>

                                            <Divider mt={4} />
                                            <Box px={8} py={4}>
                                                <SimpleGrid columns={{ base: 1, md: 2 }} gap={12}>
                                                    <FormControl isRequired isInvalid={!!(errors.firstName && touched.firstName)}>
                                                        <FormLabel htmlFor='firstName'>Nama Depan</FormLabel>
                                                        <Field
                                                            as={Input}
                                                            id='firstName'
                                                            placeholder='Nama Depan'
                                                            name={'firstName'}
                                                            validate={(value: any) => {
                                                                let error;
                                                                if (value.length <= 0) {
                                                                    error = "Nama Depan wajib diisi."
                                                                }
                                                                return error;
                                                            }}
                                                        />
                                                        <FormErrorMessage>{errors.firstName}</FormErrorMessage>
                                                    </FormControl>
                                                    <FormControl>
                                                        <FormLabel htmlFor='lastName'>Nama Belakang</FormLabel>
                                                        <Field as={Input} id='surName' name={'surName'} placeholder='Nama Belakang' />
                                                    </FormControl>
                                                </SimpleGrid>
                                            </Box>

                                            <Divider mt={4} />
                                            <Box px={8} py={4}>
                                                <SimpleGrid columns={{ base: 1, md: 2 }} gap={12}>
                                                    <FormControl>
                                                        <FormLabel htmlFor='dateOfBirth'>Tanggal Lahir</FormLabel>
                                                        <InputGroup gap={2}>
                                                            <Field as={Input} id='dateOfBirthDay' placeholder='Hari (dd)' name={'dateOfBirthDay'} />
                                                            <Field as={Select} id='dateOfBirthMonth' placeholder='Bulan' name={'dateOfBirthMonth'}>
                                                                <option value={0}>Januari</option>
                                                                <option value={1}>Febuari</option>
                                                                <option value={2}>Maret</option>
                                                                <option value={3}>April</option>
                                                                <option value={4}>Mei</option>
                                                                <option value={5}>Juni</option>
                                                                <option value={6}>Juli</option>
                                                                <option value={7}>Agustus</option>
                                                                <option value={8}>September</option>
                                                                <option value={9}>October</option>
                                                                <option value={10}>November</option>
                                                                <option value={11}>Desember</option>
                                                            </Field>
                                                            <Field as={Input} id='dateOfBirthYear' placeholder='Tahun (yyyy)' name={'dateOfBirthYear'} />
                                                        </InputGroup>
                                                    </FormControl>
                                                </SimpleGrid>
                                            </Box>

                                            <Divider mt={4} />
                                            <Box px={8} py={4}>
                                                <Box mb={4}>
                                                    <Heading fontSize={'xl'}>Lokasi</Heading>
                                                    <Text color={'gray.500'}>Agar terhubung dengan keluarga {AppConsts.APP_NAME} berada di lokasi tempat tinggal Anda.</Text>
                                                </Box>
                                                <SimpleGrid columns={{ base: 1, md: 2 }} gap={12}>
                                                    <FormControl>
                                                        <FormLabel htmlFor='city'>Kota</FormLabel>
                                                        <Field as={Input} id='city' name={'city'} placeholder='Kota' />
                                                    </FormControl>
                                                </SimpleGrid>
                                            </Box>

                                            <Divider mt={4} />
                                            <Box px={8} py={4}>
                                                <Box mb={4}>
                                                    <Heading fontSize={'xl'}>Pekerjaan</Heading>
                                                    <Text color={'gray.500'}>Agar terhubung dengan keluarga {AppConsts.APP_NAME} yang bekerja di industri yang sama.</Text>
                                                </Box>
                                                <SimpleGrid columns={{ base: 1, md: 2 }} gap={12}>
                                                    <FormControl>
                                                        <FormLabel htmlFor='profession'>Profesi</FormLabel>
                                                        <Field as={Input} id='workProfession' name={'workProfession'} placeholder='Profesi' />
                                                    </FormControl>
                                                    <FormControl>
                                                        <FormLabel htmlFor='industry'>Industri</FormLabel>
                                                        <Field as={Input} id='workIndustry' name={'workIndustry'} placeholder='Industri' />
                                                    </FormControl>
                                                </SimpleGrid>
                                            </Box>

                                            <Divider mt={4} />
                                            <Box px={8} py={4}>
                                                <FormControl>
                                                    <FormLabel htmlFor='about'>Tentang Saya</FormLabel>
                                                    <Field as={Textarea} id="about" name={'about'} placeholder='Tentang Saya' rows={5} />
                                                </FormControl>
                                            </Box>

                                            <Divider mt={4} />
                                            <Box px={8} py={4}>
                                                <Box mb={4}>
                                                    <Heading fontSize={'xl'}>Sosial Media Anda</Heading>
                                                    <Text color={'gray.500'}>Untuk keluarga {AppConsts.APP_NAME} terhubung dengan Anda.</Text>
                                                </Box>
                                                <SimpleGrid columns={{ base: 1, md: 2 }} columnGap={12} rowGap={4}>
                                                    <FormControl>
                                                        <FormLabel htmlFor='website'>Website</FormLabel>
                                                        <InputGroup>
                                                            <InputLeftElement children={<FiGlobe />} />
                                                            <Field as={Input} id='website' name={'website'} placeholder='Url Website Anda' pl={10} />
                                                        </InputGroup>
                                                    </FormControl>
                                                    <FormControl>
                                                        <FormLabel htmlFor='facebook'>Facebook</FormLabel>
                                                        <InputGroup>
                                                            <InputLeftElement children={<FiFacebook />} />
                                                            <Field as={Input} id='facebook' name={'facebook'} placeholder='Url Facebook Anda' pl={10} />
                                                        </InputGroup>
                                                    </FormControl>
                                                    <FormControl>
                                                        <FormLabel htmlFor='twitter'>Twitter</FormLabel>
                                                        <InputGroup>
                                                            <InputLeftElement children={<FiTwitter />} />
                                                            <Field as={Input} id='twitter' name={'twitter'} placeholder='Url Twitter Anda' pl={10} />
                                                        </InputGroup>
                                                    </FormControl>
                                                    <FormControl>
                                                        <FormLabel htmlFor='instagram'>Instagram</FormLabel>
                                                        <InputGroup>
                                                            <InputLeftElement children={<FiInstagram />} />
                                                            <Field as={Input} id='instagram' name={'instagram'} placeholder='Url Instagram Anda' pl={10} />
                                                        </InputGroup>
                                                    </FormControl>
                                                </SimpleGrid>
                                            </Box>

                                            <Divider mt={4} />
                                            <Box px={8} py={8}>
                                                <ButtonGroup gap={2}>
                                                    <Button type={'submit'} isLoading={isSaving}>Simpan</Button>
                                                    <Button variant={'outline'} onClick={() => { navigate('/profile') }}>Kembali</Button>
                                                </ButtonGroup>
                                            </Box>
                                        </Box>
                                    </form>
                                )
                            }
                        </Formik>
                    </Box>
                </LayoutAccount>
            </Container>
        </Layout >
    );
};

export default EditProfile;